// @flow

import React, { Fragment } from 'react';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';

import { InstagramCard, type InstagramCardProps } from './InstagramCard';

type Props = {
  cards: Array<InstagramCardProps>,
  title: string,
};

export const Instagram = ({ cards, title }: Props) => {
  if (cards.length === 0) {
    return null;
  }

  return (
    <Fragment>
      {!!title && <LineTitle>{title}</LineTitle>}
      <div className="-mx-5 overflow-x-scroll lg:overflow-x-visible" style={{ maxHeight: '280px' }}>
        <div className="flex flex-no-wrap px-5">
          {cards.map((item, index) => (
            <InstagramCard {...item} index={index} key={item.href} />
          ))}
        </div>
      </div>
    </Fragment>
  );
};
